import styled from "styled-components";

const A = styled.a`
  color: #7d8da9;
`;

export default A;
